import {type Ids} from '../state/types/state.js';

if (globalThis.crypto === undefined) {
    throw new Error('Crypto API is not available. If Running Node 18, try --experimental-global-webcrypto.');
}

/**
 * Generates a random id, using CSPRNG.
 */
export function randomId(): string {
    return globalThis.crypto.randomUUID().replaceAll('-', '');
}

export function nodeId(ids?: Ids) {
    if (ids) {
        return ids.nodeId;
    }
    return randomId();
}

export function requestId(ids: Ids): [Ids, string] {
    const nextId = ids.currentId ?? 1;
    const id = `r-${ids.nodeId}-${nextId}`;
    return [{...ids, currentId: nextId + 1}, id];
}

export function instanceId(ids: Ids): [Ids, string] {
    const nextId = ids.currentId ?? 1;
    const id = `i-${ids.nodeId}-${nextId}`;
    return [{...ids, currentId: nextId + 1}, id];
}

export function contextId(ids: Ids): [Ids, string] {
    const nextId = ids.currentId ?? 1;
    const id = `c-${ids.nodeId}-${nextId}`;
    return [{...ids, currentId: nextId + 1}, id];
}

export function activityId(ids: Ids): [Ids, string] {
    const nextId = ids.currentId ?? 1;
    const id = `a-${ids.nodeId}-${nextId}`;
    return [{...ids, currentId: nextId + 1}, id];
}

export function peerId(ids: Ids): [Ids, string] {
    const nextId = ids.currentId ?? 1;
    const id = `p-${ids.nodeId}-${nextId}`;
    return [{...ids, currentId: nextId + 1}, id];
}
